import { render, staticRenderFns } from "./GenerateTotp.vue?vue&type=template&id=a1fc2ed4&scoped=true"
import script from "./GenerateTotp.vue?vue&type=script&lang=ts"
export * from "./GenerateTotp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fc2ed4",
  null
  
)

export default component.exports